<template>
  <!-- 活动详情 -->
  <div class="g-content">
    <div class="page-activity-detail">
      <div class="header">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/volunteer/sign' }">社会活动报名</el-breadcrumb-item>
          <el-breadcrumb-item>详情</el-breadcrumb-item>
        </el-breadcrumb>
        <a class="to-back" @click="goBack">
          <i class="el-icon-back"></i>&nbsp;&nbsp;返回
        </a>
      </div>
      <el-divider></el-divider>
      <div class="content">
        <div class="head-info" style="display: table;position: relative;width: 100%;">
          <div class="pic-box" style="display: table-cell;width: 25%;vertical-align: middle;">
            <img :src="detailData.mainPic" alt>
          </div>
          <div style="display: table-cell;width:75%;">
            <el-row>
              <el-col :span="4" class="label tr">活动名称</el-col>
              <el-col :span="8" class="name">{{detailData.serviceName}}</el-col>

              <el-col :span="4" class="label tr">活动时间</el-col>
              <el-col :span="8" class="name">{{detailData.serviceTimeBegin}}~{{detailData.serviceTimeEnd}}</el-col>

              <el-col :span="4" class="label tr">活动地点</el-col>
              <el-col :span="8" class="name">{{detailData.serviceLocation}}</el-col>

              <el-col :span="4" class="label tr">年龄限制</el-col>
              <el-col :span="8" class="name">{{detailData.smallAge}}~{{detailData.bigAge}}</el-col>

              <el-col :span="4" class="label tr">活动名额</el-col>
              <el-col :span="8" class="name">{{detailData.quota}}</el-col>

              <el-col :span="4" class="label tr">已报名</el-col>
              <el-col :span="8" class="name">{{detailData.quotaAlready || 0}}</el-col>

              <el-col :span="4" class="label tr">取消报名</el-col>
              <el-col :span="8" class="name">{{detailData.cancelRegistration || 0}}</el-col>

              <el-col :span="4" class="label tr">联系电话</el-col>
              <el-col :span="8" class="name">{{detailData.tel}}</el-col>
              <!-- <el-col :span="4" class="label tr">要求</el-col>
              <el-col :span="8" class="name">{{detailData.demand}}</el-col>

              <el-col :span="4" class="label tr">取消报名</el-col>
              <el-col :span="8" class="name">{{detailData.cancelSign}}</el-col>-->
            </el-row>

          </div>
        </div>

        <div class="con mt-20">
          <h2 class="title clearfix">
            <span>当前活动状态：{{detailData.activeStatus | filterType(statusList)}}</span>
            <!-- <el-button class="fr mt-10 ml-10" @click="handleExport">导出报名表</el-button>
            <el-button type="primary" class="fr mt-10" @click="handleAdd"> 添加报名</el-button> -->
          </h2>

          <!-- 报名列表 -->
          <div class="box box-signup">
            <div class="box-inner">
              <p class="tit">报名列表</p>
              <el-button type="primary" :disabled="tableData.length <= 0" @click="exportList">导出</el-button>
            </div>
            <!-- 表格 -->
            <div class="table">
              <el-table stripe :data="tableData">
                <el-table-column label="序号" width="50">
                  <template slot-scope="scope">{{ scope.$index+1 }}</template>
                </el-table-column>
                <el-table-column prop="name" label="姓名" min-width="10%"></el-table-column>

                <el-table-column label="性别" min-width="10%">
                  <template slot-scope="scope">{{ scope.row.sex | filterType(sexList) }}</template>
                </el-table-column>

                <el-table-column prop="phone" label="手机号" min-width="10%"></el-table-column>

                <el-table-column prop="age" label="年龄" min-width="10%"></el-table-column>
                <el-table-column prop="politicalOutlook" label="政治面貌" min-width="10%">
                  <template slot-scope="scope">{{ scope.row.politicalOutlook | filterType(politicList) }}</template>
                </el-table-column>

                <el-table-column prop="time" label="报名时间" min-width="12 %"></el-table-column>
                <el-table-column label="报名状态" min-width="10%">
                  <template slot-scope="scope">{{ scope.row.status == '1' ? '正常': '取消'}}</template>
                </el-table-column>
                <el-table-column prop="isBePresent" label="是否到场" min-width="10%">
                  <template slot-scope="scope">{{ scope.row.isBePresent == '1' ? '到场': '未到场'}}</template>
                </el-table-column>
                <el-table-column prop="absentCount" label="累计未到场次数" min-width="10%"></el-table-column>
                <el-table-column prop="num" label="未到场次数" min-width="10%"></el-table-column>

                <el-table-column fixed="right" label="操作" min-width="10%">
                  <template slot-scope="scope">

                    <a class="m-btn mr-10" @click="handleOperate('1',scope.row)">到场</a>
                    <a class="m-btn mr-10 m-danger" @click="handleOperate('2',scope.row)">未到场</a>
                    <a class="m-btn m-danger" v-if="scope.row.pullBlack != 1"
                      @click="handleOperate('3',scope.row)">拉黑</a>
                  </template>
                </el-table-column>
              </el-table>

              <div class="pagination-container tr">
                <el-pagination :current-page="listQuery.page" :page-size="listQuery.size" :total="total"
                  :page-sizes="[5, 10, 15, 20, 30]" background layout="total, prev, pager, next, sizes, jumper"
                  @size-change="handleSizeChange" @current-change="handleCurrentChange" />
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <dialogAddSignup ref="dialogAddSignup" @refresh="refreshDetail"></dialogAddSignup>
  </div>
</template>

<script>
import dialogAddSignup from './dialog-add-signup'
export default {
  components: {
    dialogAddSignup
  },
  data() {
    return {
      that: this,
      defaultHeadImg: this.$store.state.app.defaultHeadImg,
      detailData: {},
      politicList: [],
      sexList: [],
      statusList: [{ dictCode: 0, dictName: '活动未开始' }, { dictCode: 1, dictName: '活动已开始' }, { dictCode: 2, dictName: '活动已结束' }, { dictCode: 3, dictName: '活动已废弃' }],
      tableData: [],
      listQuery: {
        page: 1,
        size: 5
      },
      total: 0,
      commentList: [],
    }
  },
  filters: {
    filterType(type, list) {

      let obj = list.filter(item => {
        return item.dictCode == type
      })

      if (obj && obj.length > 0) {
        return obj[0].dictName
      }

      return type
    },
  },
  methods: {
    // 初始化表格
    getDetailData() {
      this.$api.volunteer.getExternalDetail({
        id: this.$route.query.id,
        ...this.listQuery
      }).then(res => {
        if (res.success) {
          if (res.result) {
            if (res.result.recruit) {
              this.detailData = res.result.recruit
            } else {
              this.detailData = {}
            }

            if (res.result.recruitUser) {
              this.total = res.result.recruitUser.total
              this.tableData = res.result.recruitUser.records
            }
          }
        }
      })
    },

    getSelectDataByArr() {
      this.$api.common.getSelectDataByArr({ arr: ['user_info_nation', 'user_info_politic_countenance', 'new_user_info_sex'] }).then(res => {
        if (res.success) {
          let results = res.result
          this.politicList = results['user_info_politic_countenance']
          this.sexList = results['new_user_info_sex']
        }
      })

    },

    exportList() {
      if (this.tableData && this.tableData.length <= 0) {
        return
      }
      location.href = '/singleMuseum/v2/bsVolunteerV2Recruit/export?id=' + this.$route.query.id
    },

    refreshDetail() {
      this.getDetailData()
      this.restList()
    },
    // 重置查询
    restList() {
      this.listQuery.page = 1
      this.getDetailData()
    },
    handleAdd() {
      this.$refs.dialogAddSignup.init()
    },
    handleExport() {
      location.href =
        '/singleMuseum/bsActivity/exportData?key=' + this.$route.query.id
    },
    handleOperate(type, item) {
      let strMsg = '', url
      switch (type) {
        case '1':
          strMsg = '到场设置成功'
          url = 'bePresent'
          break
        case '2':
          strMsg = '未到场设置成功'
          url = 'notPresent'

          break
        case '3':
          strMsg = '拉黑操作成功'
          url = 'block'

          break
      }
      this.$api.volunteer[url]({
        id: item.id
      }).then(res => {
        if (res.success) {
          this.$message.success(strMsg)
          this.getDetailData()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 拉黑/解冻
    handleStatus(item) {
      let str = item.userDataState === '1' ? '拉黑' : '解冻'
      this.$common.confirm(
        {
          title: '您正在' + str + '用户，是否确认' + str + '？',
          className: 'cus-confirm-375'
        },
        () => {
          this.$http
            .put('/bsPubUser/removeBlack', {
              id: item.userId,
              type: item.userDataState === '1' ? '2' : '1' // 1-移出 2-移入
            })
            .then(res => {
              if (res.success) {
                this.$message.success(str + '成功')
                this.getDetailData()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },
    goBack() {
      this.$router.push({ path: '/volunteer/sign' })
    },
    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getDetailData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getDetailData()
    },
  },
  created() {
    this.getDetailData()
    this.getSelectDataByArr()
    // this.getDataList()
  }
}
</script>

<style lang="scss" scoped>
.page-activity-detail {
  .header {
    position: relative;
    .el-breadcrumb {
      font-size: 18px;
      /deep/.el-breadcrumb__inner {
        font-weight: bold;
        color: rgba(87, 89, 98, 1);
      }
      /deep/.el-breadcrumb__inner.is-link,
      .el-breadcrumb__inner a {
        color: #9699a2;
      }
    }
    .to-back {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 14px;
      color: #9699a2;
    }
  }
  .content {
    font-size: 14px;
    .head-info {
      font-size: 14px;
      // line-height: 40px;
      border: solid 1px $border;
      border-bottom: none;
      border-right: none;
      .pic-box {
        padding: 10px;
        box-sizing: border-box;
        // height: 160px;
        border-right: solid 1px $border;
        border-bottom: solid 1px $border;
        display: flex;
        img {
          max-width: 100%;
          // max-height: 100%;
          max-height: 140px;
          margin: auto;
          display: block;
        }
      }
      .label,
      .name {
        padding: 5px 20px;
        border-right: solid 1px $border;
        border-bottom: solid 1px $border;
        // height: 40px;
        line-height: 30px;
      }
      .label {
        background: #fcfcfe;
      }

      .box-flex {
        .label {
          box-sizing: border-box;
          width: 16.66667%;
        }
        .name {
          box-sizing: border-box;
          width: 33.33333%;
        }
      }
    }

    .con {
      border: solid 1px $border;
      h2.title {
        padding: 0 20px;
        line-height: 60px;
        border-bottom: solid 1px $border;
        color: $danger;
      }
      .box {
        padding: 10px 20px;
        .box-inner {
          display: flex;
          justify-content: space-between;
        }
        .tit {
          padding: 10px 0;
        }
      }
      .box.box-comment {
        .comment-list {
          padding: 20px 10px 20px 40px;
          .item {
            padding: 20px 0;
            display: flex;
            color: $color5;
            border-bottom: solid 1px $border;
            .left {
              img {
                width: 40px;
                height: 40px;
              }
            }
            .right {
              padding-left: 40px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            }
            &:nth-child(5n) {
              border-bottom: none;
            }
          }
        }
      }
    }

    .my-table-item.list {
      .label {
        border-bottom: solid 1px $border;
      }
      .txt {
        padding: 0;
      }
    }
  }
  .my-table {
    display: inline-block;
    width: 100%;

    .my-table-item {
      display: flex;
      justify-content: space-around;
      line-height: 30px;
      border: solid 1px $border;
      border-bottom: none;
      text-align: center;
      font-size: 14px;
      .txt {
        padding: 0 5px;
        border-left: solid 1px $border;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>


